// role names only; domain prefix (CONWAY/, CONWAY-AD/, CTS-AD/, CFI-AD/, etc.) is ignored when matching roles
export enum ReleaseRoles {
  TstDefaultTabigator = 'DEFAULT_TABIGATOR',
  TstInvoiceSpecialist = 'TST_LTL_INVOICE_SPECIALIST',
  TstInvoiceExl = 'TST_LTL_INVOICE_EXL',
  TstInvoiceRfc = 'TST_LTL_INVOICE_RFC',
  TstInvoiceMexico = 'TST_LTL_INVOICE_MEXICO',
  AppInvapiReleaseHeldInvoice = 'INVAPI_ReleaseHeldInvoice',

  ProdInvoiceSpecialist = 'LTL_INVOICE_SPECIALIST',
  ProdInvoiceExl = 'LTL_INVOICE_EXL',
  ProdInvoiceRfc = 'LTL_INVOICE_RFC',
  ProdInvoiceMexico = 'LTL_INVOICE_MEXICO',
}

export enum InvoiceRoles {
  DefaultTabigator = 'DEFAULT_TABIGATOR',
  TstInvoiceSpecialist = 'TST_LTL_INVOICE_SPECIALIST',
  TstInvoiceAnalyst = 'TST_LTL_INVOICE_ANALYST',
  TstInvoiceExl = 'TST_LTL_INVOICE_EXL',
  TstInvoiceMexico = 'TST_LTL_INVOICE_MEXICO',
  QAAppUse = 'QAAppUse',

  ProdInvoiceSpecialist = 'LTL_INVOICE_SPECIALIST',
  ProdInvoiceAnalyst = 'LTL_INVOICE_ANALYST',
  ProdInvoiceExl = 'LTL_INVOICE_EXL',
  ProdInvoiceMexico = 'LTL_INVOICE_MEXICO',
}

export enum RfcReferenceRoles {
  ProdSpeedyInvoicingApp = 'Application/LTLToolsAppUser_SpeedyG-InvoicingApp_PRODUCTION',
  ProdAppBillOfLadingWebApp = 'Application/LTLToolsAppUser_BillOfLadingWebApp_PRODUCTION',
}

export enum ResendRoles {
  ProdAppInvapiResendInvoice = 'Application/INVAPI_ResendInvoice',
}

export enum ForceEDIPaper {
  ProdnvapiForceEDIPaper = 'Application/INVAPI_ForceEDIPaper',
}
